import { gql } from '@apollo/client';

export const GET_PRINTER_PROFILES_QUERY = gql`
  query printerProfiles(
    $filter: PrinterProfilesFilterInput
    $limit: Int
    $skip: Int
  ) {
    printerProfiles(filter: $filter, limit: $limit, skip: $skip) {
      id
      name
      locale
      printerProfileType
      orderTypes
      grouping {
        enabled
        groupBy
        displayStyle
      }
      notifiers {
        enabled
        printerProfileIds
        displayStyle
      }
      combineIdenticalItems
      singleItemPrinting
      printing {
        printInRed
        printInRedFor
      }
      sorting {
        enabled
        sortBy
      }
    }
  }
`;
